export default __webpack_public_path__ + "static/pomtimertick-cd0506d4a5247cac91746a58fdd80941.mp4";